import { Button, Flex, Tooltip } from '@chakra-ui/react'

import {
  useInterview,
  useRegenerateShortTranscript,
} from '@/react-query/interview/interview'
import { useIsViewOnlyMember } from '@/react-query/team'
import { RefreshIcon } from '@/views/assets/RefreshIcon'
import Card from '@/views/components/Card'
import { CopyContentButton } from '@/views/components/CopyContentButton/CopyContentButton'

export const Toolbox = ({
  isCopyDisabled,
  isGenerating,
  copyRef,
}: {
  isCopyDisabled?: boolean
  isGenerating?: boolean
  copyRef: React.RefObject<HTMLDivElement | null>
}) => {
  const regenerateShortTranscript = useRegenerateShortTranscript()

  const isViewOnlyUser = useIsViewOnlyMember()
  const shortTranscript = useInterview().data?.shortTranscript || ''

  return (
    <Card className="flex flex-row justify-between items-center p-[1.25rem] flex-wrap rounded-[2.5rem] bg-[#F5F5F5] gap-y-3">
      {!isViewOnlyUser && (
        <Flex flexWrap={'wrap'} className={'gap-y-3'}>
          <Button
            variant={'brand-solid-white'}
            leftIcon={<RefreshIcon />}
            onClick={() => regenerateShortTranscript.mutate()}
            isLoading={regenerateShortTranscript.isPending}
            isDisabled={isGenerating}
          >
            Regenerate
          </Button>
        </Flex>
      )}

      <Tooltip
        rounded={'1.25rem'}
        py={2}
        px={4}
        bgColor={'blackAlpha.900'}
        label={'Please save scorecard first'}
        isDisabled={!isCopyDisabled}
        shouldWrapChildren={true}
      >
        <CopyContentButton
          isDisabled={isCopyDisabled || isGenerating}
          contentRef={copyRef}
          textCopy="Copy"
          textContent={{
            'text/plain': 'Short transcript' + '\n' + shortTranscript,
          }}
        />
      </Tooltip>
    </Card>
  )
}
